







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import InfractionRulesGrid from '../components/infraction-rules/infraction-rules-grid.vue';

@Component({
  components: {
    PageTitle,
    InfractionRulesGrid
  }
})
export default class InfractionRules extends Vue {}
